export default __webpack_public_path__ + "static/tv-show-2-ceb4effc51516fbd10c3f60994365588.jpg";